import { createSlice } from "@reduxjs/toolkit";
import { getDashboardCountAPI } from "../../api/dashboard";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getDashboardCountSlice = createSlice({
  name: "getDashboardCount",
  initialState: data,
  reducers: {
   getDashboardCountSlice(state) {
      state.isLoading = true;
    },
   getDashboardCountSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getDashboardCountSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getDashboardCountSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getDashboardCountHandler = () => async (dispatch: any) => {
  try {
    dispatch(getDashboardCountAction.getDashboardCountSlice());
    const response: any = await getDashboardCountAPI();
    
    dispatch(getDashboardCountAction.getDashboardCountSliceSuccess(response));
  } catch (e: any) {
    dispatch(getDashboardCountAction.getDashboardCountSliceFailure(e?.response?.data));
  }
};
export default getDashboardCountSlice.reducer;
export const getDashboardCountAction = getDashboardCountSlice.actions;
